import styled from 'styled-components';

import { CurrencyList } from '../../components/CurrencyList';

const StyledBarContainer = styled.div`
	position: absolute;
	right: 60px;
	top: 60px;
	display: flex;
	flex-direction: row;
	gap: 40px;
	opacity: 1;
	transition: opacity 0.3s ease;

	&.interface-enter {
		opacity: 1;
	}

	&.interface-enter-active,
	&.interface-enter-done,
	&.interface-exit {
		opacity: 0;
	}

	&.interface-exit-active {
		opacity: 1;
	}
`;

const StyledCurrencyList = styled(CurrencyList)`
	font-size: 18px;
	font-weight: 500;
`;

export { StyledBarContainer, StyledCurrencyList };
